export default __webpack_public_path__ + "static/evidence-4c74a68853140a88ca393be0f1101e51.jpg";